import debounce from 'just-debounce';

import { getHeaderOffset } from '#helpers';

export default class MessageBanner {
  constructor() {
    this.$window = $(window);
    this.$document = $(document);
    this.$body = $(document.body);
    this.$bannerTemplate = $('[data-templates] [data-message-banner]');
    this.$banners = [];

    this.header = document.querySelector('.site-header-wrapper');
    this.events = [];

    this.$document.on(
      'touchstart.message-banner, click.message-banner',
      event => {
        this._handleDocumentClick(event.target);
      }
    );
  }

  unload() {
    this.$document.off('touchstart.message-banner, click.message-banner');
  }

  message(message, type) {
    const $banner = this.$bannerTemplate.clone();

    $banner
      .addClass(`message--${type}`)
      .find('[data-message-banner-content]')
      .html(message);

    this.$body.append($banner);
    this._bindEvents($banner);
    this._show($banner);
  }

  dismissBanners() {
    const $visibleBanners = $('[data-message-banner]:visible');

    $visibleBanners.each((index, banner) => {
      this._hide($(banner), index);
    });
  }

  _bindEvents($banner) {
    this.events.push([
      $banner.on(
        'click.message-banner',
        '[data-message-banner-close]',
        event => {
          event.preventDefault();
          this._hide($banner);
        }
      ),
      this.$body.on('position-banners.message-banner', () => {
        this._positionBanner($banner);
      }),
      this.$window.on(
        'resize.message-banner',
        debounce(() => this._positionBanner($banner), 250)
      ),
      this.$window.on('scroll.message-banner', () =>
        this._positionBanner($banner)
      )
    ]);
  }

  /**
   * Position Message beneath header if its in viewport, or at top of viewport
   *
   * @param $banner
   * @private
   */
  _positionBanner($banner) {
    $banner.css({ top: getHeaderOffset(this.header, true) });
  }

  _show($banner) {
    this._positionBanner($banner);
    this.$banners.push($banner);

    $banner.addClass('animating animating-in').one('trend', () => {
      $banner
        .removeClass('animating animating-in')
        .addClass('visible')
        .off('trend');
    });
  }

  _hide($banner, index = 0) {
    $banner.addClass('animating animating-out').one('trend', () => {
      $banner.removeClass('animating animating-out visible').off('trend');
      this._removeBanner($banner, index);
    });
  }

  _removeBanner($banner, index) {
    if (this.events[index]) {
      this.events[index].forEach($el => $el.off('.message-banner'));
      this.events.splice(index, 1);
    }

    this.$banners.splice(index, 1);
    $banner.remove();
  }

  _handleDocumentClick(target) {
    const $parent = $(target).parents('[data-message-banner]');
    if ($parent.length) {
      return;
    }

    this.dismissBanners();
  }
}
